import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "@/components/layout/Sidebar";
import Header from "@/components/layout/Header";
import Breadcrumbs from "@/components/layout/Breadcrumbs";
import PageTransition from "@/components/common/PageTransition";
import PageSkeleton from "@/components/common/PageSkeleton";

export default function AppShell() {
  return (
    <div className="min-h-screen bg-matte text-white">
      <Sidebar />
      <Header />
      <main className="md:pl-64 pt-16 min-h-screen">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-8 md:py-12">
          <div className="mb-6">
            <Breadcrumbs />
          </div>
          <Suspense fallback={<PageSkeleton />}>
            <PageTransition>
              <Outlet />
            </PageTransition>
          </Suspense>
        </div>
      </main>
    </div>
  );
}
